import React from 'react';
import { Phone, Mail } from 'lucide-react';

const ProfileCard = ({ official, variant = 'simple' }) => {
  const photoUrl = official.photo ? `/assets/${official.photo}` : '/assets/placeholder.png';

  // Simplified Card for other officials
  if (variant === 'simple') {
    return (
      <div className="bg-white rounded-lg shadow-md p-4 sm:p-6 text-center h-full flex flex-col justify-between border border-slate-200/80">
        <div className="flex flex-col items-center">
          <img 
            src={photoUrl}
            alt={`Profile of ${official.name}`}
            className="w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover border-4 border-white shadow-lg mx-auto mb-3"
          />
          <h3 className="text-md sm:text-lg font-bold text-slate-800">{official.nameHindi}</h3>
          <p className="text-sm text-slate-500 mb-3">{official.roleHindi}</p>
        </div>
        {(official.mobile || official.email) && (
            <div className="border-t border-slate-200 pt-3 mt-3">
                <div className="flex justify-center items-center space-x-2 sm:space-x-4 text-xs text-slate-600">
                    {official.mobile && 
                        <a href={`tel:${official.mobile}`} className="flex items-center space-x-1 sm:space-x-1.5 hover:text-blue-600">
                            <Phone size={14} />
                            <span>{official.mobile}</span>
                        </a>
                    }
                    {official.mobile && official.email && <span className="text-slate-300">|</span>}
                    {official.email && 
                        <a href={`mailto:${official.email}`} className="flex items-center space-x-1 sm:space-x-1.5 hover:text-blue-600">
                            <Mail size={14} />
                            <span>Email</span>
                        </a>
                    }
                </div>
            </div>
        )}
      </div>
    );
  }

  // Full, Detailed Card for Chaudhary Charan Singh
  return (
    <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-200/80">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start p-4 md:p-6">
        
        {/* Photo and Basic Info Column */}
        <div className="md:col-span-1 text-center flex flex-col items-center">
          <img 
            src={photoUrl}
            alt={`Profile of ${official.name}`}
            className="w-32 h-32 sm:w-40 sm:h-40 rounded-full object-cover border-8 border-white shadow-2xl mx-auto aspect-square"
          />
          <h2 className="mt-4 text-xl sm:text-2xl font-bold text-slate-900">{official.nameHindi}</h2>
          <p className="text-sm sm:text-md text-slate-600">{official.roleHindi}</p>
           {official.birth && official.death && (
            <div className='text-xs text-center text-slate-500 mt-1 font-mono'>
              ({official.birth} &ndash; {official.death})
            </div>
          )}
        </div>

        {/* Detailed Info Column */}
        <div className="md:col-span-2">
          {official.bio && (
            <div className="text-left pt-4 md:pt-0">
              <p className='text-base sm:text-md text-slate-700 leading-relaxed text-center md:text-left'>{official.bio}</p>
              
              {official.timeline && (
                <div className="mt-6">
                  <h4 className="font-bold text-lg text-center md:text-left text-slate-800 mb-3">Political Journey</h4>
                  <ul className="text-sm text-slate-700 space-y-3">
                    {official.timeline.map((item, index) => (
                      <li key={index} className="flex items-start bg-slate-50/80 p-2 rounded-md">
                        <span className="font-semibold text-slate-800 w-24 flex-shrink-0">{item.period}</span>
                        <span className="flex-1 pl-3 border-l-2 border-blue-200">{item.event}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default ProfileCard;
